import { useEffect } from 'react';
import useProto from '~/client/features/Proto/hooks/useProto';
import ProtoCommands from '~/client/features/Proto/utils/ProtoCommands';
import useLoginError from '~/client/hooks/user/useLoginError';
import AuthStepsEnum from '../../AuthStepsEnum';
import useStepByStepAuthContext from '../../context/hooks/useStepByStepAuthContext';
import useLoginOrSignupSubmit from '../../hooks/helpers/useLoginOrSignupSubmit';
import CommsCommands from '@/client/helpers/CommsCommands';

const use2FAStep = () => {
  const { isProtoEnabled } = useProto();
  const { setStep, clearErrors } = useStepByStepAuthContext();
  const { resetError, error } = useLoginError();
  const { socialAuthType } = useLoginOrSignupSubmit({});
  const handleOpenComms = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    event.preventDefault();
    if (isProtoEnabled) {
      ProtoCommands.open();
    } else {
      CommsCommands?.show?.({});
    }
  };

  const handleMoreOptionsClick = () => {
    resetError();
    setStep?.(AuthStepsEnum.MoreOptions);
  };

  useEffect(() => {
    if (socialAuthType && error.includes('OTP_IS_REQUIRED')) {
      resetError();
    }
  }, [socialAuthType, resetError, error, clearErrors]);

  const handleClearErrors = () => {
    clearErrors?.();
  };

  return {
    handleOpenComms,
    handleMoreOptionsClick,
    handleClearErrors,
  };
};

export default use2FAStep;
